// extracted by mini-css-extract-plugin
export default {"imageWrapper":"TD-z","hovered":"UD-z","hoverImage":"VD-z","mainImage":"WD-z","imageNoBackground":"XD-z","fullSizeImage":"YD-z"};